/* T26: Use Enterprise's modal lifecycle and Shopify's native contact submission. */
customElements.whenDefined('modal-dialog').then(() => {
  if (customElements.get('t26-wholesale-inquiry')) return;

  class T26WholesaleInquiry extends customElements.get('modal-dialog') {
    connectedCallback() {
      this.t26Events?.abort();
      this.t26Events = new AbortController();
      const options = { signal: this.t26Events.signal };
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-t26-choice]')) this.t26SyncChoices();
      }, options);
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-t26-remove]');
        if (!remove) return;
        const choice = document.getElementById(remove.dataset.t26Remove);
        choice.checked = false;
        this.t26SyncChoices();
        choice.focus();
      }, options);
      this.form.addEventListener('submit', (event) => this.t26Submit(event), options);
      window.addEventListener('pageshow', () => {
        this.t26SetLoading(false);
        this.t26SyncChoices();
      }, options);

      const country = this.querySelector('[data-t26-country]');
      const defaultCountry = country.dataset.t26Default;
      const match = Array.from(country.options).find((option) =>
        defaultCountry && (option.value === defaultCountry || option.textContent.trim() === defaultCountry));
      if (!country.value && match) country.value = match.value;
      this.t26SyncChoices();

      const url = new URL(window.location.href);
      const isReturn = url.searchParams.get('t26_wholesale') === this.id
        || url.hash === `#${this.form.id}`;
      const success = this.querySelector('[data-t26-success]');
      if (isReturn && (success.dataset.t26Posted === 'true' || this.querySelector('[data-t26-server-errors]'))) {
        const sent = success.dataset.t26Posted === 'true';
        success.hidden = !sent;
        this.querySelector('[data-t26-fields]').hidden = sent;
        this.open(document.querySelector(`[aria-controls="${this.id}"]`));
        url.searchParams.delete('t26_wholesale');
        url.searchParams.delete('contact_posted');
        if (url.hash === `#${this.form.id}`) url.hash = '';
        window.history.replaceState(window.history.state, '', url);
      }
    }

    disconnectedCallback() {
      if (this.hasAttribute('open')) super.close();
      this.t26Events.abort();
    }

    t26SyncChoices() {
      let count = 0;
      this.querySelectorAll('[data-t26-choice]').forEach((choice) => {
        const row = document.getElementById(choice.getAttribute('aria-controls'));
        row.hidden = !choice.checked;
        row.querySelector('[data-t26-quantity]').disabled = !choice.checked;
        if (choice.checked) count += 1;
      });
      this.querySelector('[data-t26-count]').textContent = `${count} selected`;
      this.querySelector('[data-t26-empty]').hidden = count > 0;
      this.querySelector('[data-t26-selection-error]').hidden = true;
    }

    t26Submit(event) {
      if (this.submitButton.disabled) {
        event.preventDefault();
        return;
      }
      const rows = Array.from(this.querySelectorAll('[data-t26-row]')).filter((row) => !row.hidden);
      if (!rows.length) {
        event.preventDefault();
        this.querySelector('[data-t26-selection-error]').hidden = false;
        this.querySelector('[data-t26-choice]')?.focus();
        return;
      }
      if (!this.form.reportValidity()) {
        event.preventDefault();
        return;
      }
      this.querySelector('[data-t26-summary]').value = rows.map((row) => {
        const sku = row.dataset.t26Sku ? ` | SKU: ${row.dataset.t26Sku}` : '';
        return `${row.dataset.t26Label}${sku} | Quantity: ${Number(row.querySelector('[data-t26-quantity]').value)} yards`;
      }).join('\n');
      this.t26SetLoading(true);
    }

    t26SetLoading(loading) {
      this.submitButton.disabled = loading;
      this.submitButton.setAttribute('aria-busy', String(loading));
      this.submitButton.classList.toggle('t26-is-loading', loading);
      this.querySelector('[data-t26-submit-label]').textContent = loading ? 'Sending...' : 'Send wholesale inquiry';
    }

    close() {
      super.close();
      const success = this.querySelector('[data-t26-success]');
      if (!success.hidden) {
        success.hidden = true;
        this.querySelector('[data-t26-fields]').hidden = false;
        this.t26SetLoading(false);
      }
    }
  }

  customElements.define('t26-wholesale-inquiry', T26WholesaleInquiry);
});
